import "./Homes.jsx"
import "./Expolar.css"
const Expolar =() => {
    return(
        <>
        <section className="blog">
            <h5>𝓑𝓛𝓞𝓖</h5>
            <p>Try our most popular signature cupcakes and taste the difference!</p>

      
        <div className="card">
            <h2>Fresh baked sweetness</h2>
            <img src="latest-1.png" alt="" />
            <p>Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet consectetur adipisicing elit.. <br />Lorem ipsum dolor, sit amet consectetur adipisicing elit.</p>
            <button className="Btn">Read more..</button>
    </div>

    <div className="card">
            <h2> Citrus Bliss</h2>
            <img src="latest-2.png" alt="" />
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel, dolore !bakers<br>
            </br> Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
            <button className="Btn">Read more..</button>
    </div>
    </section>


    
       
        </>

    )
}

export default Expolar;